import { isTest as a } from "./Environment.js";
const d = (t) => class extends t {
  constructor() {
    super(...arguments), this.linksWithClickListeners = [], this.isClickTrackingEnabled = !1;
  }
  enableClickTracking() {
    this.isClickTrackingEnabled = !0;
  }
  handleApiError(e, i) {
    if (e.hasOwnProperty("requestId")) {
      const s = e;
      this.sendAnalyticsEvent(`${i}-api-error`, { requestId: s.requestId, endpoint: s.endpoint, method: s.method, response: JSON.stringify(s), status: s.status });
    } else {
      const s = e;
      a() || console.error(s), this.sendError(s);
    }
  }
  sendAnalyticsEvent(e, i) {
    o(e, { componentName: this.tagName.toLowerCase(), ...i });
  }
  sendError(e) {
    c(e);
  }
  updated(e) {
    super.updated(e), this.isClickTrackingEnabled && this._updateLinkClickListeners();
  }
  _updateLinkClickListeners() {
    var i;
    const e = ["a", "sp-top-nav-item", "sp-sidenav-item", "LinkableCard"];
    for (const s of e) {
      const r = ((i = this.shadowRoot) == null ? void 0 : i.querySelectorAll(s)) || [];
      for (const n of r) this.linksWithClickListeners && !this.linksWithClickListeners.includes(n) && (n.addEventListener("click", () => {
        this.sendAnalyticsEvent("link-click", { className: n.className, href: n.href });
      }), this.linksWithClickListeners.push(n));
    }
  }
};
function o(t, e) {
  window.dispatchEvent(new CustomEvent("af-analytics", { detail: { eventName: t, ...e } }));
}
function c(t) {
  window.newrelic !== void 0 && window.newrelic && window.newrelic.noticeError(t);
}
export {
  d as Analytics,
  o as sendAnalyticsEvent,
  c as sendError
};
//# sourceMappingURL=Analytics.js.map
